import { Theme, theme } from '@branchjs/neo-components';
import Popover from '@mui/material/Popover';
import * as React from 'react';

import { Global, css } from '@emotion/core';
import type { ApplicationType } from '../../../../shared/types/ApplicationType';
import AppEntry from './AppEntry';
import { appsMenuStyles } from './AppsMenu.styles';

const APP_TYPE = {
  DISCO: 'disco',
  SAAS: 'saas',
};

export const AppsMenu = ({ onChange, active }: { onChange: (app: ApplicationType) => void; active: ApplicationType }) => {
  const { button, popover } = appsMenuStyles;

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Theme>
      <Global
        styles={css`
          .MuiPopover-paper {
            background: ${theme.colors.primary.contrastWhite};
            box-shadow: ${theme.shadows[2]} !important;
            border-radius: ${theme.spacing(1)} !important;
          }
        `}
      />
      <div onClick={handleClick} data-testid="btn-to-apps" className={button}>
        <i className="material-icons">apps</i>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={popover} data-testid="app-pop-content">
          <div data-testid="btn-to-saas" onClick={onChange?.bind(this, APP_TYPE.SAAS)}>
            <AppEntry type="disco" active={active === APP_TYPE.SAAS} text="SaaS" />
          </div>
          <div data-testid="btn-to-disco" onClick={onChange?.bind(this, APP_TYPE.DISCO)}>
            <AppEntry type="saas" active={active === APP_TYPE.DISCO} text="Discovery" />
          </div>
        </div>
      </Popover>
    </Theme>
  );
};
